module.exports = __webpack_public_path__ + "static/media/code.d7ef8adb.svg";